// Angular
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';

// localforage
import * as localforage from 'localforage';

@Component({
  selector: 'oh-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss'],
})
export class BackButtonComponent {
  @Input()
  beginning: boolean;
  @Input()
  question: number;

  constructor(private router: Router) {}

  goBack() {
    if (this.beginning) {
      localforage.removeItem('oh-active-user');
      this.router.navigate(['/welcome']);
    } else {
      if (this.question) {
        this.router.navigate([], { queryParams: { question: this.question - 1 } });
      } else if (this.question === 0) {
        this.router.navigate(['/sign-in']);
      } else {
        window.history.back();
      }
    }
  }
}
